import { getCookies, removeCookies, setCookie } from 'cookies-next';

export function getUserToken(): { isLoggedIn: boolean; token: string } {
  const cookies = getCookies();

  const sessionCookie = cookies.stk;

  return { isLoggedIn: !!sessionCookie, token: sessionCookie || '' };
}

export function setUserToken(token: string): void {
  setCookie('stk', token, { maxAge: 365 * 24 * 60 * 60, sameSite: 'strict' });
}

export function logout(): void {
  removeCookies('stk');
}
